import styled from 'styled-components'

export default styled.div`
  display: flex;
  position: relative;
  width: 100%;
  max-width: 100px;
  border-radius: 20px;
  background: ${ ({ theme }) => theme.colors.almostWhite };
  align-items: center;
  padding: 4px 8px;
  cursor: pointer;

  img {
    pointer-events: none;
  }

  .value {
    width: 100%;
    display: flex;
    flex: 1 1 0%;
    font-size: 16px;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0 5px 0 0;
    color: ${ ({ theme }) => theme.colors.black };
    background: transparent;
    border: none;
    box-shadow: none;
    pointer-events: none;

    &::placeholder {
      color: ${ ({ theme }) => theme.colors.black };
      font-family: ${ ({ theme }) => theme.fontFamily };
    }
  }
`
